<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="drawer" temporary app>
      <template v-slot:prepend>
        <v-list-item class="px-2">
          <v-list-item-avatar>
            <img :src="require('@/assets/usuario.png')" />
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{usuario}}</v-list-item-title>
            <v-list-item-subtitle>{{correo}}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>
      <v-divider></v-divider>
      <v-list>
        <v-list-item v-for="item in items" :key="item.title" :to="item.action" :id="item.id">
          <v-list-item-icon>
            <v-icon color="primary"> {{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>
      <v-list-item @click="dialog = true">
        <v-list-item-icon>
          <v-icon color="primary">mdi-logout</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Cerrar Sesión</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-switch v-model="$vuetify.theme.dark" inset label="Modo Escuro" persistent-hint></v-switch>
      </v-list-item>
    </v-navigation-drawer>

    <v-app-bar app color="primary">
      <v-app-bar-nav-icon 
        id="btn-sidebar"
        class="white--text" 
        @click="drawer = !drawer"
      ></v-app-bar-nav-icon>

      <v-toolbar-title class="white--text">{{ message }}</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon class="white--text" @click="dialog_help = true">
        <v-icon>mdi-help-circle</v-icon>
      </v-btn>
    </v-app-bar>

    <v-main>
      <router-view></router-view>
    </v-main>
    <v-footer app inset="true">
      <v-col class="lighten-2 py-0 text-center" cols="12">
        <span class="px-4">&copy; {{ new Date().getFullYear() }} - Desarrollado por <a href="sdib.com.mx"
            target="_blank">SDIB</a></span>
      </v-col>
    </v-footer>
    <!-- MODAL DE CERRAR SESION -->
    <v-dialog v-model="dialog" max-width="400px">
      <v-card>
        <v-card-title class="text-h5 text-center">¿Estas seguro de cerrar sesión?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">Cancelar</v-btn>
          <v-btn color="blue darken-1" text @click="cerrarSesion">Cerrar Sesión</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- MODAL PARA VISULIZAR CONTACRTO-->
    <v-dialog v-model="dialog_contrato" persistent width="1200px">
      <v-card>
        <v-card-title>
          <span class="text-h5">Terminos y Condiciones</span>
        </v-card-title>
        <v-card-text>
          <pdf style="display: none;" :src="url" @num-pages="pageCount = new Array($event)" />
          <pdf v-for="(page, index) in pageCount" :key="index" :src="url" :page="index + 1" />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="aceptarContrato()">
            Aceptar Terminos
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--DIALOG DE AYUDA  -->
    <v-dialog v-model="dialog_help" max-width="450">
      <v-card>
        <v-card-title class="text-h5 text-center">
          Reporte de problemas en sistema
        </v-card-title>
        <v-card-text>
          Telefono/whatsapp Soporte:
          <br />
          <a href="https://wa.me/524773576653" target="_blank">
            +52477-357-66-53
          </a>
          <br />
          Horario de Atención:
          <br />
          <b> 9:00 AM - 7:00 PM</b>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialog_help = false">
            De Acuerdo
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- DIALOG CONFIRMAR TOUR -->
    <v-dialog v-model="dialog_tour" max-width="420">
      <v-card>
        <v-card-title class="text-h5 text-center">
          Configuracion de contrato
        </v-card-title>

        <v-card-text class="text-center">
          ¿Deseas continuar con el recorrido para modificar la impresion de tu contrato ?
        </v-card-text>
        <v-card-text class="text-center">
          Te mostraremos la forma de lorgarlo
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn text color="primary" @click="continuarTour" >
            Continuar
          </v-btn>

          <v-btn text color="grey darken-1" @click="omitirTour" >
            Omitir
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import service from "@/core/Servicio.js";
import pdf from "vue-pdf";
import { driver } from "driver.js";
import "driver.js/dist/driver.css";

export default {
    components: {
    pdf
  },
  data() {
    return {
      message: "Luthue Digital Cliente",
      usuario: "",
      correo: "",
      dialog:false,
      dialog_help:false,
      pageCount: [],
      url: process.env+"/TERMINOS%20Y%20CONDICIONES.pdf",
      dialog_contrato:false,
      dialog_tour:false,
      drawer: null,
      items: [
        { id:"sec_envios", title: "Envios", icon: "mdi-cube-send", action: "envios" },  
        { id:"sec_informacion", title: "Información", icon: "mdi-account-settings-outline", action: "informacion" },    
        { id:"sec_nuevo_envio", title: "Nuevo Envio", icon: "mdi-email", action: "nuevo" },    
      ],
    };  
  },
  mounted() {
    this.initialize();
    let tour_completado = localStorage.getItem("tour_completado") || "0";
    let requiere_tour = localStorage.getItem("requiere_tour");

    if (this.$route.path !== "/informacion" && tour_completado !== "1" && requiere_tour == "1") {
      setTimeout(() => {
        this.dialog_tour = true;
      }, 100);
    }

  },
  methods: {
     initialize() {
      if (localStorage.getItem("id") == null) {
        this.$router.push("/");
      }else{
        this.usuario = localStorage.getItem("nombre");
        this.correo = localStorage.getItem("correo");
        //Validamos que ya haya leido el contrato
        /*if(localStorage.getItem("contrato") == 0){
          this.dialog_contrato = true;
        }*/
      }
    },
    cerrarSesion(){
      localStorage.removeItem("id");
      localStorage.removeItem("nombre");
      localStorage.removeItem("correo");
      localStorage.removeItem("contrato");
      localStorage.removeItem("rfc");
      localStorage.removeItem("direccion");
      localStorage.removeItem("telefono");
      localStorage.removeItem("requiere_tour");
      this.dialog = false;
      this.$router.push("/");
    },
    aceptarContrato(){
      let params = {
          cliente_id: localStorage.getItem("id"),
        };
        service
          .aceptar_contrato(params)
          .then((response) => {
            this.loader = false;
            if (response.data.response_flag == 1) {
              this.dialog_contrato = false;
              //localStorage.setItem("contrato",1);
            }
          })
          .catch(() => {
           console.log("Error");
          });
    },
    continuarTour() {
      this.dialog_tour = false;

      setTimeout(() => {
        this.iniciarTour();
      }, 300);
    },
    omitirTour(){
      this.dialog_tour = false;
      localStorage.setItem("tour_completado", "1");
    },
    iniciarTour() {
      const driverObj = driver({
        showProgress: false,
        allowClose: false,
        nextBtnText: 'Continuar <i class="mdi mdi-arrow-right"></i>',
        prevBtnText: '<i class="mdi mdi-arrow-left"></i> Anterior',
        doneBtnText: 'Continuar <i class="mdi mdi-arrow-right"></i>',
        //doneBtnText: 'Finalizar <i class="mdi mdi-check"></i>',
        steps: [
          {
            element: "#btn-sidebar",
            popover: {
              title: "Seleccionar Módulo",
              description: "Haz clic aquí para abrir el menú lateral.",
              side: "bottom",
              align: "start",
              onNextClick: () => {
                driverObj.moveNext();
                this.drawer = true;
              }
            }
          },
          {
            element: ".v-navigation-drawer",
            popover: {
              title: "Menú lateral",
              description: "Desde aquí puedes acceder a los módulos del sistema.",
              side: "right",
              align: "start"
            }
          },
          {
            element: "#sec_informacion",
            popover: {
              title: "Información",
              description: "Aquí puedes modificar la información de tu cuenta.",
              onNextClick: () => {

                localStorage.setItem("tour_contrato", "1");

                this.$router.push("/informacion");
              }
            }
          }
        ]
      });

      driverObj.drive();
    }
  },
};
</script>
